routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
    $stateProvider
        .state('home.contactDetailId', {
            url: __env.routes.contactDetailId,
            template: `<contact-detail sh-ctrl="shCtrl"></contact-detail>`
        });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/contact-detail/contact-detail.config.js
 **/